import React from 'react';
import { WalletProvider } from './context/WalletContext';
import { ChainProvider } from './context/ChainContext';
import AppRoutes from './AppRoutes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './App.css';
import TransactionQueue from './components/TransactionQueue';
import MaintenanceMode from './components/MaintenanceMode';

const App = () => {
  return (
    <ChainProvider>
      <WalletProvider>
        <div className="app">
          <AppRoutes />
          <ToastContainer
            position="top-right"
            autoClose={3000}
            hideProgressBar={false}
            newestOnTop
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="dark"
          />
          <TransactionQueue />
          <MaintenanceMode />
        </div>
      </WalletProvider>
    </ChainProvider>
  );
};

export default App;
